import { ErrorOutline } from "@mui/icons-material";
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Stack,
} from "@mui/material";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { XButton } from "share-components/mui-wrap/button/x-button";

export const ValidationErrorPopup = observer(() => {
  const {
    validationErrorStore: { show, setProp, errorMessage },
  } = useStores();

  return (
    <Dialog open={show} fullWidth maxWidth={"sm"}>
      <DialogTitle component={Stack}>
        <Stack direction={"row"} spacing={1} alignContent={"center"}>
          <ErrorOutline></ErrorOutline>
          <Box>Dữ liệu chưa hợp lệ</Box>
        </Stack>
      </DialogTitle>
      <DialogContent>
        <DialogContentText color={(theme) => theme.palette.error.dark}>
          {errorMessage}
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <XButton variant="text" onClick={() => setProp("show", false)}>
          Đóng
        </XButton>
      </DialogActions>
    </Dialog>
  );
});
